import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import { ExperienceController } from './controllers/Experience';
import { Landing } from './controllers/Landing';
import { Edition } from './controllers/Edition';
import { Preview } from './controllers/Preview';

const App: React.FunctionComponent = () => {
  return (
    <BrowserRouter>
      <Routes>
        {/* i.e. http://localhost:3008/?ticketCode=FUXT-LMCZ-WSIY-JGAV&siteKey=OZckQZty&customerUid=yanisbreton */}
        <Route path="/" element={<ExperienceController />} />
        {/* i.e. http://localhost:3008/landing?ticketCode=FUXT-LMCZ-WSIY-JGAV&siteKey=OZckQZty&customerUid=yanisbreton */}
        <Route path="/landing" element={<Landing />} />
        {/* i.e. http://localhost:3002/edition */}
        <Route path="/edition/:screenType" element={<Edition />} />
        {/* i.e. http://localhost:3002/preview/628e1dec2323922d99c321dd */}
        <Route path="/preview/:campaignId" element={<Preview />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
